// `VITE_BASE_PATH` helpers — avoid undefined prefix / double slash bugs.
/** Normalize a base to start and end with a single slash. */
const normalizeBasePath = (base = "/"): string => {
  const value = base || "/";
  const withLeading = value.startsWith("/") ? value : `/${value}`;
  return withLeading.endsWith("/") ? withLeading : `${withLeading}/`;
};

/** Strip the trailing slash (`/` stays `/`). */
const stripTrailingSlash = (base = "/"): string => {
  const normalized = normalizeBasePath(base);
  return normalized === "/" ? "/" : normalized.slice(0, -1);
};

/** Join a relative path onto a base, collapsing duplicate slashes. */
const joinBasePath = (base = "/", path = ""): string =>
  `${normalizeBasePath(base)}${path.replace(/^\/+/, "")}`;

const APP_BASE_PATH = import.meta.env.VITE_BASE_PATH || "/";

/** Base path with leading & trailing slash. */
export const getBasePath = (): string => normalizeBasePath(APP_BASE_PATH);

/** Base path for React Router `basename` (no trailing slash). */
export const getRouterBasename = (): string =>
  stripTrailingSlash(APP_BASE_PATH);

/** Prefix a relative path/asset with the base path. */
export const withBasePath = (path = ""): string =>
  joinBasePath(APP_BASE_PATH, path);
